<div class="tip-component mx-auto my-3">
    <div class="section-title p-3 mb-0 pl-4 font-size-primary font-weight-bold theme-light">
        {{'public.standalonepayment.paymentpage.addTipPercentage' | translate}}</div>
    <div class="tip-button-wrapper">
        <div class="tip-sec mx-2 my-4">
            <div class="d-flex">
                <a href="#" class="button text-center py-2 mx-2 text-unselectable" appPreventDoubleClick
                    [throttleTime]="5000" *ngFor="let item of getCustomTips()"
                    [ngClass]="item.position == selectedTipPosition ? 'dark' : 'border rounded'"
                    (throttledClick)="onTipChange(item)">
                    <div>{{item.tipPercentage * 100}}%</div>
                    <div>{{item.tipAmount | formatPrice:
                        customTipData.locale:customTipData.currencyIsoCode:customTipData.currencySymbol}}</div>
                </a>
            </div>
            <div class="d-flex my-2">
                <a href="#" class="button text-center py-2 mx-2 text-unselectable" appPreventDoubleClick
                    [throttleTime]="5000" *ngFor="let item of getDefaultTips()"
                    [ngClass]="item.position == selectedTipPosition ? 'dark' : 'border rounded'"
                    (throttledClick)="onTipChange(item, item.custom)">
                    <div *ngIf="!item.custom">
                        <div>0%</div>
                        <div>{{'public.standalonepayment.paymentpage.noTip' | translate}}</div>
                    </div>
                    <div *ngIf="item.custom">
                        <span>{{'public.standalonepayment.paymentpage.others' | translate}}</span>
                    </div>
                </a>
                <form [formGroup]="tipAmountForm" class="form-wrapper mx-2 my-auto" [ngClass]="selectedTipPosition == localTips?.possibleTips[localTips?.possibleTips?.length-1]?.position ? 'show' : 'hide'">
                    <div class="price-input item-wrapper mx-2">
                        <span>{{localTips.currencySymbol}}</span>
                        <input type="text" name="specificAmount" formControlName="specificAmount" class="form-control"
                            id="var-specific-amount" (keyup)='onCustomAmountChange()' mask="separator.2" maxlength="7"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>